import { render } from "./ApproveModal.vue?vue&type=template&id=9c19aeee&ts=true"
import script from "./ApproveModal.vue?vue&type=script&lang=ts"
export * from "./ApproveModal.vue?vue&type=script&lang=ts"

import "./ApproveModal.vue?vue&type=style&index=0&id=9c19aeee&lang=scss"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__